<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import Notification from "@/views/pages/dashboard/notification";
import NotificationNotSet from "@/views/pages/dashboard/notification_not_set.vue";
import NotificationHazardous from "@/views/pages/dashboard/notification_hazardous.vue";
import NotificationInquiries from "@/views/pages/dashboard/inquiries.vue";
import NotificationExpiration from "@/views/pages/dashboard/notification_expirations.vue";
import WorkOrders from "@/views/pages/dashboard/work_orders.vue";

import appConfig from "@/app.config";

/**
 * dashboard component
 */
export default {
  page: {
    title: "ホーム",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Notification,
    NotificationNotSet,
    NotificationHazardous,
    NotificationInquiries,
    NotificationExpiration,
    WorkOrders,
  },
  data() {
    return {
      showModal: false,
      hasRemand: false,
    };
  },
  methods:{
    viewWorkOrderMessage(data){
      this.hasRemand = data;
    },
  },
};
</script>

<template>
  <Layout>
    <div v-if="hasRemand" class="alert alert-warning">
      <i class="mdi mdi-block-helper me-2"></i>
      差戻の作業指示情報が存在します
    </div>
    <Notification />
    <NotificationNotSet />
    <NotificationHazardous />
    <NotificationInquiries />
    <NotificationExpiration />
    <WorkOrders @view-work-order-message="viewWorkOrderMessage" />
  </Layout>
</template>
